module.exports = __webpack_public_path__ + "img/EnglishEx.d32a3fff.svg";